import { NgModule, ModuleWithProviders } from '@angular/core';
import { OidcConfigService } from './auth-oidc-client/services/oidc.security.config.service';
import { OidcSecurityService } from './auth-oidc-client/services/oidc.security.service';
import { OidcSecurityValidation } from './auth-oidc-client/services/oidc.security.validation';
import { OidcSecurityCheckSession } from './auth-oidc-client/services/oidc.security.check-session';
import { OidcSecurityUserService } from './auth-oidc-client/services/oidc.security.user-service';
import { OidcSecuritySilentRenew } from './auth-oidc-client/services/oidc.security.silent-renew';
import { OidcSecurityCommon } from './auth-oidc-client/services/oidc.security.common';
import { AuthConfiguration } from './auth-oidc-client/modules/auth.configuration';
import { TokenHelperService } from './auth-oidc-client/services/oidc-token-helper.service';
import { OidcDataService } from './auth-oidc-client/services/oidc-data.service';
import { StateValidationService } from './auth-oidc-client/services/oidc-security-state-validation.service';
import { BrowserStorage, OidcSecurityStorage } from './auth-oidc-client/services/oidc.security.storage';
import { LoggerService } from './auth-oidc-client/services/oidc.logger.service';
import { ArrayHelperService } from './auth-oidc-client/services/oidc-array-helper.service';
import { AuthWellKnownEndpoints } from './auth-oidc-client/models/auth.well-known-endpoints';
import { AuthenticateService } from './authenticate.service';
import { AuthInterceptorProvider } from './auth-interceptor';

@NgModule()
export class AuthenticateModule {
  static forRoot(token: Token = {}): ModuleWithProviders<AuthenticateModule> {
    return {
      ngModule: AuthenticateModule,
      providers: [
        OidcConfigService,
        OidcSecurityService,
        OidcSecurityValidation,
        OidcSecurityCheckSession,
        OidcSecuritySilentRenew,
        OidcSecurityUserService,
        OidcSecurityCommon,
        AuthConfiguration,
        TokenHelperService,
        LoggerService,
        ArrayHelperService,
        AuthWellKnownEndpoints,
        OidcDataService,
        StateValidationService,
        {
          provide: OidcSecurityStorage,
          useClass: token.storage || BrowserStorage
        },
        AuthenticateService,
        AuthInterceptorProvider
      ]
    };
  }
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export interface Type<T> extends Function {
  new (...args: any[]): T;
}

export interface Token {
  storage?: Type<any>;
}
